import { spawn } from 'redux-saga/effects';

import { watchGetCountries } from './getCountries';

export default function* saga() {
  yield spawn(watchGetCountries);
}
